import floatingLabel from './floatingLabel';

const els = document.querySelectorAll('.form-item--with-floating-label');

for (let el of els) {
    floatingLabel(el);
}
